import {
  Flex, Text, Button, Box
} from '@huspy/briks-web';
import { Image } from '@mantine/core';
import { BaseSlido } from '@modules/core/components/BaseSlido';
import useDeleteOpportunityApplicant from '@modules/opportunities/entities/opportunity/mutation/useDeleteOpportunityApplicant';
import { imagesPath } from '@shared/css.const';
import { useTranslation } from 'react-i18next';

export const DeleteApplicantSlido = ({
  opportunityId,
  applicantId,
  close,
  opened,
  updateOpportunity,
}: {
  opportunityId: string;
  applicantId: string;
  close: () => void;
  opened: boolean;
  updateOpportunity: () => Promise<void>;
}) => {
  const { t } = useTranslation();

  const baseTranslation = 'opportunity.caseSubmission.documentSubmission.pendingForms.deleteApplicant';
  const {
    mutateAsync: deleteApplicant,
    isPending: isDeletingApplicant,
  } = useDeleteOpportunityApplicant(opportunityId);

  return (
    <BaseSlido
      opened={ opened }
      close={ () => {
        close();
      } }
      title={ (
        <Text size='3xl' px='4' py='8' weight='medium'>
          { t(`${baseTranslation}.header`) }
        </Text>
      ) }
      footer={ (
        <Flex w='100%' justify='space-between'>
          <Button
            variant='secondary'
            data-testid='skip-btn'
            onClick={ async () => {
              close();
            } }
          >
            {t(`${baseTranslation}.skipButton`)}
          </Button>
          <Button
            variant={ isDeletingApplicant ? 'secondary' : 'primary' }
            disabled={ isDeletingApplicant }
            loading={ isDeletingApplicant }
            data-testid='proceed-btn'
            onClick={ async () => {
              await deleteApplicant({ applicantId });
              await updateOpportunity();
            } }
          >
            {t(`${baseTranslation}.saveButton`)}
          </Button>
        </Flex>
      ) }
    >
      <Flex
        direction='column'
        h='100%'
        justify='space-between'
      >
        <Flex bg='white' p='4' borderRadius='4' direction='column' my='2'>
          <Box w='100%' mb='2'>
            <Image src={ `${imagesPath}/missing-fields.png` } w='100%' />
          </Box>
          <Text size='3xl' my='2'>
            {t(`${baseTranslation}.title`)}
          </Text>
          <Text size='md' my='2' color='text-secondary'>
            {t(`${baseTranslation}.description`)}
          </Text>
        </Flex>
      </Flex>
    </BaseSlido>
  );
};
